module.exports = __webpack_public_path__ + "static/media/drone.25b24544.svg";